import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import update from "immutability-helper";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { Link, withRouter } from "react-router-dom";
import moment from "moment-timezone";

// Components
import Loader from "../../utils/Loader";
import PromotionFields from "./PromotionFields";
import Searchbar from "../../utils/Searchbar";
import SearchPromotion from "../../search/SearchPromotion";

// State
import { userTokenUpdate, userLogout } from "../../../store/actions/user";
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../shared/vars";

// Utils
import "../../../utils/immutability-helper-extend";

class AdminPromotionsFormEdit extends Component {
	constructor(props) {
		super(props);

		this.state = {
			item: {
				id: !!props.match.params.id ? props.match.params.id : null
			},
			promotions: [],
			errors: {},
			addSuccess: !!props.successMessage ? props.successMessage : "",
			updateErrors: {},
			updateSuccess: "",
			isLoading: true,
			isLoadingSinglePromotion: false,
			updateLoading: false,
			deletionInProgress: false,
			timezone: moment.tz.guess()
		};
	}

	componentDidMount() {
		this.loadAllPromotionsSelected();

		// Load selected promotion
		if (!!this.state.item.id) {
			this.loadSinglePromotion();
		}
	}

	componentWillReceiveProps(nextProps) {
		const prevId = !!this.props.match.params.id ? this.props.match.params.id : null;
		const nextId = !!nextProps.match.params.id ? nextProps.match.params.id : null;

		if (prevId !== nextId) {
			this.setState(
				{
					item: {
						id: nextId
					}
				},
				() => {
					if (!!nextId) {
						this.loadSinglePromotion();
					}
				}
			);
		}
	}

	loadSinglePromotion() {
		this.setState(
			{
				isLoadingSinglePromotion: true
			},
			() => {
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
				return axios
					.get(REACT_APP_API_URL + "promotion/" + this.state.item.id, { headers: AUTH_HEADER })
					.then(response => {
						if (response.status === 403 || (response.data.status && response.data.status === 403)) {
							this.props.userLogout("admin");
						} else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							this.setState({ isLoadingSinglePromotion: false, error: response.data.message });
						} else {
							const flatCategories = map(response.data[0].categories, "category_id");

							// Ensure dates are valid
							let start = moment(response.data[0].start);
							let end = moment(response.data[0].end);

							response.data[0].sale_start = start.isValid() ? moment.utc(response.data[0].start).local() : null;
							response.data[0].sale_end = end.isValid() ? moment.utc(response.data[0].end).local() : null;

							this.setState({
								isLoadingSinglePromotion: false,
								item: {
									...response.data[0],
									sale_type: response.data[0].sale_type === "dollar",
									categories: flatCategories,
									initiallySelectedCategories: flatCategories
								}
							});
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({ isLoadingSinglePromotion: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
						} else {
							this.setState({ isLoadingSinglePromotion: false, error: err.message });
						}
					});
			}
		);
	}

	loadAllPromotionsSelected() {
		this.setState(
			{
				isLoading: true
			},
			() => {
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
				return axios
					.get(REACT_APP_API_URL + "promotion", { headers: AUTH_HEADER })
					.then(response => {
						if (response.status === 403 || (response.data.status && response.data.status === 403)) {
							this.props.userLogout("admin");
						} else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							this.setState({ isLoading: false, error: response.data.message });
						} else {
							this.setState({
								isLoading: false,
								promotions: response.data
							});
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message });
						} else {
							this.setState({ isLoading: false, error: err.message });
						}
					});
			}
		);
	}

	// ===================================================================================
	//  INPUT CHANGE
	// ===================================================================================
	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			this.submitItem();
		}
	}

	handleChange(value, name) {
		if (name === "sale_start" || name === "sale_end") {
			value = moment(value)
				.utc()
				.format();
		}

		this.setState({
			item: update(this.state.item, {
				[name]: { $set: value }
			})
		});
	}

	handleCheckboxClick(name) {
		this.setState({
			item: update(this.state.item, {
				[name]: { $set: !this.state.item[name] }
			})
		});
	}

	handleCheckboxCollectionClick(name, value) {
		const index = !!this.state.item[name] ? this.state.item[name].indexOf(value) : -1;

		// Remove from "categories" array, or add
		this.setState({
			item: update(this.state.item, {
				[name]: {
					$autoArray: index > -1 ? { $splice: [[index, 1]] } : { $push: [value] }
				}
			})
		});
	}

	// ===================================================================================
	//  SUBMIT
	// ===================================================================================
	submitItem() {
		const { user } = this.props;
		const { item } = this.state;

		this.setState(
			{
				updateLoading: true,
				updateSuccess: "",
				addSuccess: "",
				updateErrors: {}
			},
			() => {
				const data = item;
				item.sale_type = !!this.state.item.sale_type ? "dollar" : "percentage";

				const token = user.token;
				const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
				return axios
					.post(REACT_APP_API_URL + "promotion", data, { headers: AUTH_HEADER })
					.then(response => {
						// Check user token
						if (!!response.data.token) {
							this.props.userTokenUpdate("admin", response.data.token);
						} else {
							this.props.userLogout("admin");
						}

						if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
							// Create error object
							let errorObj = "";
							if (!isEmpty(response.data.errors)) {
								errorObj = response.data.errors;
							} else if (!isEmpty(response.data.error)) {
								errorObj = { general: response.data.error };
							} else {
								errorObj = { general: response.data.message };
							}

							this.setState({
								updateLoading: false,
								updateErrors: errorObj
							});
						} else {
							// Redirect to edit route
							if (!data.id) {
								this.props.history.push({
									pathname: "/admin/promotions/" + response.data.id,
									state: {
										successMessage: response.data.message
									}
								});
							}

							this.setState({
								updateLoading: false,
								updateSuccess: response.data.message
							});
						}
					})
					.catch(err => {
						if (err.response) {
							this.setState({
								updateLoading: false,
								updateErrors: { general: err.response.data.error ? err.response.data.error : err.response.data.message }
							});
						} else {
							this.setState({
								updateLoading: false,
								updateErrors: { general: err.message }
							});
						}
					});
			}
		);
	}

	// ===================================================================================
	//  DELETE
	// ===================================================================================
	handleDelete(permalink) {
		const { user } = this.props;

		this.setState({
			deletionInProgress: true,
			deleteErrors: {},
			deleteSuccess: "",
			updateSuccess: "",
			addSuccess: "",
			updateErrors: {}
		});

		const token = user.token;
		const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY + ":Bearer " + token };
		return axios
			.delete(REACT_APP_API_URL + "promotion/" + this.state.item.id, { headers: AUTH_HEADER })
			.then(response => {
				if (!!response.data.token) {
					this.props.userTokenUpdate("admin", response.data.token);
				} else {
					this.props.userLogout("admin");
				}

				if (response.data.status === 403) {
					this.props.userLogout("admin");
				} else if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
					this.setState({
						deletionInProgress: false,
						deleteErrors: !isEmpty(response.data.errors) ? response.data.errors : response.data.message
					});
				} else {
					this.setState({
						deletionInProgress: false,
						deleteSuccess: response.data.message
					});
				}
			})
			.catch(err => {
				if (err.response) {
					this.setState({
						deletionInProgress: false,
						deleteErrors: err.response.data.error ? err.response.data.error : err.response.data.message
					});
				} else {
					this.setState({
						deletionInProgress: false,
						deleteErrors: err.message
					});
				}
			});
	}

	handleDeleteRedirect() {
		this.props.history.push("/admin/promotions");
	}

	// ===================================================================================
	//  RENDER
	// ===================================================================================
	render() {
		return (
			<div>
				<h1>Promotions</h1>

				{this.state.isLoading || this.state.isLoadingSinglePromotion ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<div>
						{this.state.error ? (
							<div className="error msg_animate">{this.state.error}</div>
						) : (
							<div>
								{!!this.state.addSuccess ? (
									<div className="success msg_animate" key="success">
										{this.state.addSuccess}
									</div>
								) : null}

								<PromotionFields item={this.state.item} promotions={this.state.promotions} errors={this.state.updateErrors} handleKeyPress={this.handleKeyPress.bind(this)} handleChange={this.handleChange.bind(this)} handleCheckboxClick={this.handleCheckboxClick.bind(this)} handleCheckboxCollectionClick={this.handleCheckboxCollectionClick.bind(this)} submitItem={this.submitItem.bind(this)} updateLoading={this.state.updateLoading} updateSuccess={this.state.updateSuccess} deletionInProgress={this.state.deletionInProgress} deleteErrors={this.state.deleteErrors} deleteSuccess={this.state.deleteSuccess} handleDelete={this.handleDelete.bind(this)} handleDeleteRedirect={this.handleDeleteRedirect.bind(this)} />

								<div className="fieldset">
									{!!this.state.item.id ? (
										<Link to="/admin/promotions">Create a New Promotion</Link>
									) : (
										[
											<div key="0" className="title-label">
												Edit Promotions
											</div>,
											<Searchbar key="1" placeholder={"Search promotions"} component={SearchPromotion} searchEndpoint={"search/promotions"} {...this.props} userType="admin" />
										]
									)}
								</div>
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.user.admin
	};
};

export default withRouter(connect(mapStateToProps, { userTokenUpdate, userLogout })(AdminPromotionsFormEdit));



// WEBPACK FOOTER //
// ./src/components/admin/promotions/AdminPromotionsFormEdit.js